import React from 'react'
import './background.css'

export default function Background(){
    return(
        <div className='bg'> 
            <span></span>
            <span></span>
            <span></span>
            <span></span>
            <span></span>
            <span></span>
            <span></span>
            <span></span>
            <span></span>
        </div>
    )
        
}